export default "__VITE_ASSET__CNFXLkAc__"